import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from 'firebase/functions';
import { getDatabase} from "firebase/database";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {

  apiKey: "AIzaSyCVgtR0FRn-4-TpHqnP8sIDCrNYiOw6P1I",
  authDomain: "ratio-6392b.firebaseapp.com",
  projectId: "ratio-6392b",
  storageBucket: "ratio-6392b.firebasestorage.app",
  messagingSenderId: "894406002772",
  appId: "1:894406002772:web:cd763ab0b14c7fd49085c1",
  measurementId: "G-79ZMX5E782",
  databaseURL: "https://ratio-6392b-default-rtdb.firebaseio.com",
  vapidKey: "BLxW-E0jquXBimlDPTuPtcu0FeEl3yFZK0ZZs7KywbL01GGKpuas3CQRjR9ofrRlweHLDoyx_NxrNN2evy9ZBCM"

  /*apiKey: "AIzaSyBu0uhvQOM6usuZ4ZyNFovd55S676GSMHc",
  authDomain: "solidflow-debate.firebaseapp.com",
  projectId: "solidflow-debate",
  storageBucket: "solidflow-debate.firebasestorage.app",
  messagingSenderId: "4077080044",
  appId: "1:4077080044:web:b666590b9de4c61aa184c9",
  measurementId: "G-75B71YJQ45",
  databaseURL: "https://solidflow-debate-default-rtdb.firebaseio.com",
  vapidKey: "BGmvwwC5_8DEMS-3wpnTO8f1lfpsmNCsnQ0e84-sjUZhU1PL5uXDAbjfoM84ZSsPo4t4Q-TGB8nAceioibZ7fYk"*/
  
};
const protocol = window.location.protocol;
const domain =  window.location.hostname;
const port =  window.location.port;

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const firestore = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app);
const analytics = getAnalytics(app);
const db = getDatabase(app);
var messaging = null;//

if(protocol == 'https:') {
	messaging = getMessaging(app);
}

//connectAuthEmulator(auth, "http://192.168.1.151:9099");

export { messaging, app, auth, firestore, storage, functions, analytics, db, firebaseConfig };
